import { useState, useCallback } from 'react';
import { Button, Icon, Stack, Tooltip } from '@mui/material';
import LayersIcon from '@mui/icons-material/Layers';
import { useTranslation } from '@chr/online-shared-ui-localizations';

import { MapLayerControls } from './MapLayerControls';
import { MapKey } from './MapKey';

export const MapKeyAndContentButtons = () => {
  const translate = useTranslation();

  const [showLayers, setShowLayers] = useState(false);
  const [showMapKey, setMapKey] = useState(false);

  const toggleMapKey = useCallback(() => {
    setShowLayers(false);
    setMapKey(!showMapKey);
  }, [setShowLayers, setMapKey, showMapKey]);

  const toggleLayers = useCallback(() => {
    setMapKey(false);
    setShowLayers(!showLayers);
  }, [setShowLayers, setMapKey, showLayers]);

  return (
    <>
      {showMapKey && <MapKey onClose={toggleMapKey} />}
      {showLayers && <MapLayerControls toggleLayers={toggleLayers} />}

      <Stack
        direction="row"
        gap={1}
        sx={{
          position: 'absolute',
          bottom: '40px',
          right: '30px'
        }}
      >
        <Tooltip title={translate('Map key')} placement="top">
          <Button
            data-testid='map-content-button'
            variant="outlined"
            onClick={toggleMapKey}
            sx={{
              borderStyle: 'solid',
              borderColor: 'primary.main',
              backgroundColor: showMapKey ? 'map.controls.key.active' : 'background.surface',
              minWidth: 'auto',
              [`&:hover`]: {
                backgroundColor: 'map.controls.key.hover'
              },
              [`&:active`]: {
                backgroundColor: 'map.controls.key.active'
              }
            }}
            aria-label="Map key"
          >
            <Icon>info</Icon>
          </Button>
        </Tooltip>
        <Button
          variant="contained"
          startIcon={<LayersIcon />}
          onClick={toggleLayers}
          sx={{
            backgroundColor: showLayers ? 'map.controls.content.primary' : 'primary.main',
            borderWidth: '2px',
            borderStyle: 'solid',
            borderColor: showLayers ? 'map.controls.content.action.active.secondary' : 'primary.main',
            '&:hover': {
              backgroundColor: 'primary.dark',
              borderColor: 'map.controls.content.action.hover.primary'
            },
            '&:active': {
              backgroundColor: 'map.controls.content.action.active.primary',
              borderColor: 'map.controls.content.action.active.secondary'
            }
          }}
        >
          {translate('Map Content')}
        </Button>
      </Stack>
    </>
  );
};
